import { prop } from '@ipfabric/utils/fp/prop';
import { selectMultiple } from 'pages/ComponentGallery/gallerySections/MultiplesGenerator/model/selectors/selectMultiple';
import type { FC } from 'react';
import { useMultiplesGeneratorContextSelectors } from '../model/MultiplesGeneratorModel';

export const NumberDetail: FC = () => {
  const ctxProps = useMultiplesGeneratorContextSelectors({
    baseNumber: prop('baseNumber'),
    multiple: selectMultiple,
  });
  return (
    <p>
      {`Some random multiple of ${ctxProps.baseNumber}: ${ctxProps.multiple ?? 'not generated yet'}`}
    </p>
  );
};
